
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import DeductionsSummarySection from '@components/ssap/pages/pageIncludes/summary/summaryIncludes/DeductionsSummarySection';
import IncomesSummarySection from '@components/ssap/pages/pageIncludes/summary/summaryIncludes/IncomesSummarySection';
import SummaryFilter from '@components/ssap/pages/pageIncludes/summary/SummaryFilter';
import TribalIncomeSummarySection from '@components/ssap/pages/pageIncludes/summary/summaryIncludes/TribalIncomeSummarySection';

// Utils

import { dateMethods } from '@utils/dates/dateMethods';
import { transformDropdownOptionsToObject } from '@utils/normalize/transformDropdownOptionsToObject';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { FORMATTED_DATES } from '@constants/individualPortal/dashboard/dashboardModelTypes';

// Types

import { SsapSummaryType } from '@components/ssap/SsapTypes';


const SourcesSummary = props => {

    const NOT_APPLICABLE = 'NOT_APPLICABLE';
    const NOT_APPLICABLE_TEXT_ID = 'common.not_applicable';

    const INCOME_SOURCES_LIST = transformDropdownOptionsToObject([
        ...DROPDOWN_OPTIONS.INCOME_SOURCES,
        {
            value: NOT_APPLICABLE,
            text: NOT_APPLICABLE_TEXT_ID
        }
    ]);

    const FREQUENCIES_LIST = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.FREQUENCY);

    const {
        applicantGuid,
        incomes,
        expenses,
        isFinalSummaryPage,
        isSsapInReviewMode,
        isState,
        previousData,
        reportedIncome
    } = props;

    const processDate = date => {
        return date ?
            dateMethods.getFormattedDate(FORMATTED_DATES.commonDate, date) :
            <FormattedMessage id = { NOT_APPLICABLE_TEXT_ID }/>;
    };
    
    return (
        <Fragment>
            <SummaryFilter summaryId = { SsapSummaryType.INCOMES }>
                <IncomesSummarySection
                    { ...{
                        applicantGuid,
                        constants: {
                            NOT_APPLICABLE
                        },
                        incomes,
                        isFinalSummaryPage,
                        isSsapInReviewMode,
                        isState,
                        lists: {
                            INCOME_SOURCES_LIST,
                            FREQUENCIES_LIST
                        },
                        previousData,
                        processDate,
                        reportedIncome
                    } }
                />
            </SummaryFilter>
            <SummaryFilter summaryId = { SsapSummaryType.DEDUCTIONS }>
                <DeductionsSummarySection
                    { ...{
                        applicantGuid,
                        expenses,
                        isFinalSummaryPage,
                        isSsapInReviewMode,
                        lists: {
                            FREQUENCIES_LIST
                        },
                        previousData,
                        processDate
                    } }
                />
            </SummaryFilter>
            <SummaryFilter summaryId = { SsapSummaryType.TRIBAL_INCOMES }>
                <TribalIncomeSummarySection
                    { ...{
                        applicantGuid,
                        incomes,
                        isFinalSummaryPage,
                        isSsapInReviewMode,
                        lists: {
                            FREQUENCIES_LIST,
                            INCOME_SOURCES_LIST
                        },
                        previousData
                    } }
                />
            </SummaryFilter>
        </Fragment>
    );
};

export default SourcesSummary;